import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Cube: FunctionComponent<IconProps> = ({
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 39 44"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2468 0.735003L22.25 0.73686L36.25 8.73685C36.9511 9.14161 37.5413 9.68781 37.9929 10.3276C38.0947 10.4243 38.1846 10.5371 38.2584 10.6648C38.323 10.7764 38.3716 10.8929 38.4049 11.0116C38.789 11.7686 38.9991 12.6165 39 13.4944V29.4959C38.998 31.4588 37.95 33.2735 36.25 34.2549L36.2442 34.2583L22.25 42.2549L22.2468 42.2568C21.6312 42.6117 20.9639 42.8381 20.2824 42.9359C20.0546 43.0755 19.7867 43.1559 19.5 43.1559C19.2133 43.1559 18.9454 43.0755 18.7176 42.9359C18.036 42.838 17.3688 42.6116 16.7531 42.2567L16.75 42.2549L2.75579 34.2583L2.75 34.2549C1.05004 33.2735 0.00201416 31.4604 0 29.4974V13.4959C0.000900916 12.6179 0.211076 11.7683 0.595261 11.0113C0.62856 10.8927 0.677113 10.7763 0.741628 10.6648C0.815456 10.5372 0.905211 10.4245 1.00693 10.3278C1.45862 9.68794 2.04886 9.14167 2.75 8.73686L2.75578 8.73352L16.7531 0.735066C18.4532 -0.245001 20.5467 -0.245022 22.2468 0.735003ZM21 39.514L34.75 31.6569L34.7526 31.6554C35.5238 31.2089 35.9991 30.3856 36 29.4944V13.7041L21 22.3811V39.514ZM18 22.3811V39.514L4.25 31.6569L4.24742 31.6554C3.47644 31.209 3.00117 30.3861 3 29.4951V13.7041L18 22.3811ZM20.7558 3.33826L34.4252 11.1493L19.5 19.783L4.57485 11.1493L18.2442 3.33826L18.25 3.33494C19.0235 2.88835 19.9765 2.88835 20.75 3.33494L20.7558 3.33826Z"
        fill="#327EA5"
      />
    </svg>
  </IconWrapper>
);

Cube.displayName = 'Cube';
